<script lang="ts">
    import {getDateFormatter, getInjector, getLocalization} from 'core/svelte-context/context';
    import {KpFooterService} from 'shared/components/kp-footer/kp-footer.service';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpLocaleSelect from 'shared/components/kp-locale/KpLocaleSelect.svelte';
    import KpsysTextLogo from 'shared/components/kp-footer/components/KpsysTextLogo.svelte';

    const service = getInjector().getByToken<KpFooterService>(KpFooterService.serviceName);

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();
</script>

<footer class="kp-footer footer-container">
    <div class="custom-footer">
        <slot name="custom-footer"/>
    </div>

    <div class="links-footer footer-block-logo">
        <div class="container links-logo-container">
            <div class="col-md-8 logo-container">
                <a href="https://verbis.io" target="_blank">
                    <img src="/resources/img/brand/verbis-logo-orange.svg" height="30" alt="verbis.io"/>
                </a>
            </div>

            <div class="col-md-4 notForPrint links-container">
                <div>
                    <a href="https://help.verbis.io">
                        {localize(/* @kp-localization util.Help */ 'util.Help')}
                    </a>
                </div>
                <div>
                    <a href="/#!/attributions">
                        {localize(/* @kp-localization attributions.FooterLinkLabel */ 'attributions.FooterLinkLabel')}
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="footer container">
        <div class="row">
            <div class="col-lg-5 footer-block-left">
                <div class="row">
                    <div class="col-lg-12 about">
                        {localize(/* @kp-localization commons.systemBylVyvinutFirmou */ 'commons.systemBylVyvinutFirmou')}

                        <a href="https://kpsys.cz" target="_blank">
                            <KpsysTextLogo/>
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 version">
                        {localize(/* @kp-localization commons.VerzeSystemu */ 'commons.VerzeSystemu')}
                        {pipe(service.portaroVersion.date, dateFormatter('d.M.yyyy H:mm:ss'))}
                        ({service.portaroVersion.branch} {service.portaroVersion.value})
                    </div>
                </div>
            </div>

            <div class="col-lg-4 footer-block-center notForPrint">
                <div class="row">
                    <div class="col-lg-12 rss">
                        <a type="application/rss+xml" href="/rss">RSS</a>

                        {#if !service.currentDepartment.root}
                            <div class="col-lg-12 current-department">{pipe(service.currentDepartment, loc())}</div>
                        {/if}
                    </div>
                </div>
            </div>

            <nav class="col-lg-3 footer-block-right notForPrint">
                {#if service.switchableLanguages.length > 0}
                    <ul class="lang-list">
                        {#each service.switchableLanguages as lang}
                            <li class="{lang.id}">
                                <KpLocaleSelect locale="{lang.id}">{pipe(lang, loc())}</KpLocaleSelect>
                            </li>
                        {/each}
                    </ul>
                {/if}

                {#if service.isForAdministrationOnly && !service.currentAuth.evided}
                    <button class="login-button unset-style pull-right" on:click="{() => service.login()}">
                        {localize(/* @kp-localization login.menuLoginButton */ 'login.menuLoginButton')}
                    </button>
                {/if}

                {#if service.currentAuth.evided}
                    <a class="pull-right" href="/logout">
                        {localize(/* @kp-localization login.odhlasit */ 'login.odhlasit')}
                    </a>
                {/if}
            </nav>
        </div>
    </div>
</footer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    @footer-text-size: 11px;
    @footer-top-border: #D3D3D3;
    @footer-text-color: #999;

    .footer-container {
        border-top: 1px solid @footer-top-border;
        padding-top: @spacing-l;
        font-size: @footer-text-size;
        margin-top: auto;

        .footer-block-logo {
            .links-logo-container {
                padding-top: @spacing-s;
                padding-bottom: @spacing-sm;

                .links-container {
                    text-align: right;
                    padding: 0;
                }

                .logo-container {
                    padding: 0;
                }
            }
        }

        .footer {
            padding-top: @spacing-sm;
            padding-bottom: @spacing-sm;
            color: @footer-text-color;

            .footer-block-left {
                text-align: left;

                .about {
                    display: flex;
                    align-items: center;
                    gap: @spacing-s;
                }
            }

            .footer-block-center {
                text-align: center;
            }

            .footer-block-right {
                text-align: right;

                .lang-list {
                    li {
                        padding: @spacing-xs 0;

                        a {
                            background-repeat: no-repeat;
                            background-position: right center;
                        }
                    }
                }
            }
        }
    }
</style>